<template>
    <div class="bg-color">
        <Navbar />
        <Header :category="'visitors'" :bannerTitle="bannerTitle" :breadCrumb="borrowSpaceCrumb" />
        <NewsContent />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
    import Navbar from 'components/DefaultHome/Layout/NavbarStyleTwo'
    import Header from 'components/DefaultHome/KECC5G/Common/Header'
    import NewsContent from './NewsContent'
    import FooterTop from 'components/DefaultHome/Layout/FooterTop'
    import FooterBottom from 'components/DefaultHome/Layout/BacktopButton'
    export default {
        name: 'NewsMain',
        components: {
            Navbar,
            Header,
            NewsContent,
            FooterTop,
            FooterBottom,
        },
        data() {
            return {
                bannerTitle: this.$t('navbar.menu_7'),
                borrowSpaceCrumb: [
                    {
                        name: this.$t('navbar.menu_7'),
                        path: "/news"
                    }
                ]
            }
        }
    }
</script>
